module.exports = __webpack_public_path__ + "static/media/exclamation.ee8467c7.png";